module.exports = __webpack_public_path__ + "img/116.29f32208.jpg";